import PromotionPage from './promotion-page'

export default PromotionPage;